/**
 * Formats a number as Indian Rupee (INR) currency.
 * e.g., 123000 -> ₹1,23,000
 * @param amount The amount to format
 * @param maximumFractionDigits The number of decimal places (default 0)
 * @returns The formatted string
 */
export const formatCurrency = (amount: number, maximumFractionDigits: number = 0): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits,
  }).format(amount);
};

export const getUserRoleLabel = (user?: { user_type?: string; creator_sub_type?: string }): string => {
  if (!user || !user.user_type) return 'Creator';
  const userType = user.user_type.toLowerCase();
  if (userType === 'creator') {
    const subType = user.creator_sub_type?.toLowerCase();
    if (subType === 'photographer') return 'Photographer';
    if (subType === 'videographer') return 'Videographer';
    if (subType === 'both') return 'Photographer - Videographer';
    return 'Creator';
  }
  if (userType === 'model') return 'Model';
  if (userType === 'hirer') return 'Hirer';
  // Capitalize fallback
  return user.user_type.charAt(0).toUpperCase() + user.user_type.slice(1);
};

